import expandPrimaryButtonVariables from './expand-primary-button-variables';
import expandSecondaryButtonVariables from './expand-secondary-button-variables';
import {
  getPrimaryButtonVariableNames,
  getSecondaryButtonVariableNames,
} from './get-button-variable-names';
import { variableVariants } from '../constants/variable-names';

const getAdvancedColorsToReset = (variableName, buttonPreset = null) => {
  if (variableName.includes('primary_button')) {
    const [, pbVariableVariants] = getPrimaryButtonVariableNames(buttonPreset);
    return [variableName, ...Object.values(pbVariableVariants[variableName])]
      .map(expandPrimaryButtonVariables)
      .flat();
  }

  if (variableName.includes('secondary_button')) {
    const [, sbVariableVariants] = getSecondaryButtonVariableNames(buttonPreset);
    return [variableName, ...Object.values(sbVariableVariants[variableName])]
      .map(expandSecondaryButtonVariables)
      .flat();
  }

  const variants = variableVariants[variableName];
  if (variants) {
    return [variableName, ...Object.values(variants)];
  }

  return [variableName];
};

export default getAdvancedColorsToReset;
